import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_LOCALE_MUTATION = graphql(`
  mutation EditMessageThreadLocale($id: ID!, $locale: String) {
    editMessageThread(id: $id, input: { locale: $locale }) {
      id
      locale
      type
    }
  }
`);

export default EDIT_MESSAGE_THREAD_LOCALE_MUTATION;
